module.exports = __webpack_public_path__ + "img/alpha.fd957095.svg";